import { UIComponent } from "../../components";
import api from "../../api";

export class AITemplateCreate extends UIComponent {
    init() {
        this.hide();
        this.setupComponents();
        this.initTemplateBlocks();
        this.bindEvents();
        this.isEditMode = false;
        this.editTemplateId = null;
        this.parentComponent = null;
    }

    setupComponents() {
        this.includeComponents({
            modal: "document@#modalAiTemplates",
        });
        this.originalTemplateBlock = this.templateBlock?.[0];
    }

    bindEvents() {
        this.addBlockBtn?.on("click", () => this.addTemplateBlock());
        this.saveTemplateBtn?.on("click", () => this.saveTemplate());
    }
    
    showEdit(templateData) {
        this.prepareEditMode(templateData);
        this.clearAllBlocks();
        this.createBlocksFromData(templateData.content || []);
        this.show();
    }

    prepareEditMode(templateData) {
        this.isEditMode = true;
        this.editTemplateId = templateData.id;
        this.edit_url = templateData.editUrl || templateData.links?.update;
        this.setTitle(templateData.name || "");
    }

    resetEditState() {
        this.isEditMode = false;
        this.editTemplateId = null;
        this.edit_url = null;
    }
    
    clearAllBlocks() {
        if (!this.templateBlock || this.templateBlock.length === 0) return;
        
        while (this.templateBlock.length > 0) {
            const block = this.templateBlock[0];
            this.removeBlockFromDOM(block);
            this.templateBlock.splice(0, 1);
        }
    }

    createBlocksFromData(description) {
        if (!description || description.length === 0) return;
        
        description.forEach((blockData, index) => {
            if (index === 0) {
                this.createFirstBlock(blockData);
            } else {
                this.addTemplateBlock(blockData);
            }
        });
        
        this.updateMoveButtonsVisibility();
    }

    createFirstBlock(blockData = null) {
        if (!this.originalTemplateBlock?.element || !this.addBlockBtn?.element?.parentNode) {
            return;
        }

        const blockElement = this.cloneBlockElement(0);
        const block = this.createCard(blockElement);
        
        if (block) {
            if (blockData) {
                this.populateBlock(block, blockData);
            } else {
                this.clearBlock(block);
            }
            
            this.setupBlockListeners(block);
            this.templateBlock.push(block);
        }
    }

    addTemplateBlock(blockData = null) {
        if (!this.originalTemplateBlock?.element || !this.addBlockBtn?.element?.parentNode) {
            return;
        }

        try {
            const newIndex = this.templateBlock.length;
            const blockElement = this.cloneBlockElement(newIndex);
            const newBlock = this.createCard(blockElement);
            
            if (newBlock) {
                if (blockData) {
                    this.populateBlock(newBlock, blockData);
                } else {
                    this.clearBlock(newBlock);
                }
                
                this.setupBlockListeners(newBlock);
                this.templateBlock.push(newBlock);
                this.updateMoveButtonsVisibility();
            }
        } catch (error) {
            console.error("Ошибка при добавлении блока:", error);
        }
    }

    cloneBlockElement(index) {
        const clone = this.originalTemplateBlock.element.cloneNode(true);
        clone.querySelectorAll("[tbx-id]").forEach(el => el.removeAttribute("tbx-id"));
        clone.removeAttribute("tbx-id");
        clone.setAttribute("data-block-index", index);
        
        this.addBlockBtn.element.parentNode.insertBefore(clone, this.addBlockBtn.element);
        return clone;
    }

    populateBlock(block, data) {
        if (block.blockTitle?.element) {
            block.blockTitle.element.textContent = data.title || "";
        }
        if (block.blockText?.element) {
            block.blockText.element.value = data.text || "";
            this.adjustTextareaHeight(block.blockText.element);
        }
    }

    clearBlock(block) {
        if (block.blockTitle?.element) {
            block.blockTitle.element.textContent = "";
        }
        if (block.blockText?.element) {
            block.blockText.element.value = "";
            block.blockText.element.style.height = "auto";
        }
    }

    removeBlock(block) {
        if (!block?.element?.parentNode || this.templateBlock.length <= 1) return;

        this.removeBlockFromDOM(block);
        this.removeBlockFromArray(block);
        this.reindexRemainingBlocks();
        this.updateMoveButtonsVisibility();
    }

    removeBlockFromDOM(block) {
        if (block.element?.parentNode) {
            block.element.parentNode.removeChild(block.element);
        }
    }

    removeBlockFromArray(block) {
        const index = this.templateBlock.indexOf(block);
        if (index > -1) {
            this.templateBlock.splice(index, 1);
        }
    }

    reindexRemainingBlocks() {
        this.templateBlock.forEach((block, index) => {
            if (block.element) {
                block.element.setAttribute("data-block-index", index);
            }
        });
    }

    moveBlock(block, direction) {
        const element = block?.element;
        if (!element) return;

        const currentIndex = this.getBlockIndex(block);
        const newIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;
        const targetBlock = this.findBlockByIndex(newIndex);

        if (!targetBlock) return;

        this.swapBlockIndices(block, targetBlock);
        this.swapBlockElements(block, targetBlock, direction);
        this.updateMoveButtonsVisibility();
    }

    getBlockIndex(block) {
        return parseInt(block.element?.dataset?.blockIndex || "0");
    }

    findBlockByIndex(index) {
        return this.templateBlock.find(block => this.getBlockIndex(block) === index);
    }

    swapBlockIndices(block1, block2) {
        const index1 = this.getBlockIndex(block1);
        const index2 = this.getBlockIndex(block2);
        
        block1.element.dataset.blockIndex = index2;
        block2.element.dataset.blockIndex = index1;
    }

    swapBlockElements(block1, block2, direction) {
        if (direction === "up") {
            block1.element.parentNode.insertBefore(block1.element, block2.element);
        } else {
            block1.element.parentNode.insertBefore(block2.element, block1.element);
        }
    }
    
    initTemplateBlocks() {
        this.templateBlock?.forEach(block => this.setupBlockListeners(block));
        this.updateMoveButtonsVisibility();
    }

    setupBlockListeners(block) {
        block?.removeBlockBtn?.on("click", () => this.removeBlock(block));
        block?.blockMoveUp?.on("click", () => this.moveBlock(block, "up"));
        block?.blockMoveDown?.on("click", () => this.moveBlock(block, "down"));
    }

    updateMoveButtonsVisibility() {
        if (!this.templateBlock || this.templateBlock.length === 0) return;

        const sortedBlocks = this.getSortedBlocks();
        sortedBlocks.forEach((block, index) => {
            this.updateBlockMoveButton(block.blockMoveUp, index === 0, "disable-top");
            this.updateBlockMoveButton(
                block.blockMoveDown, 
                index === sortedBlocks.length - 1, 
                "disable-down"
            );
        });
    }

    getSortedBlocks() {
        return [...this.templateBlock].sort(
            (a, b) => this.getBlockIndex(a) - this.getBlockIndex(b)
        );
    }

    updateBlockMoveButton(button, isDisabled, className) {
        if (!button) return;
        button[isDisabled ? "addClass" : "removeClass"](className);
    }

    adjustTextareaHeight(textarea) {
        if (!textarea?.element) return;
        textarea.element.style.height = "auto";
        textarea.element.style.height = textarea.element.scrollHeight + "px";
    }

    setTitle(title) {
        if (this.templateTitle?.element) {
            this.templateTitle.element.textContent = title;
        }
    }

    clearTitle() {
        this.setTitle("");
    }
  
    async saveTemplate() {
        if (!this.validateForm()) return;

        this.startLoading();
        
        try {
            const templateData = this.prepareTemplateData();
            const response = await this.sendTemplateData(templateData);
            
            if (response) {
                this.handleSaveSuccess(response);
            }
        } catch (error) {
            this.handleSaveError(error);
        } finally {
            this.stopLoading();
        }
    }

    validateForm() {
        const title = this.templateTitle?.element?.textContent?.trim();
        const hasContent = this.templateBlock?.some(block => {
            const blockTitle = block.blockTitle?.element?.textContent?.trim();
            const blockText = block.blockText?.element?.value?.trim();
            return blockTitle || blockText;
        });

        return title && hasContent;
    }

    prepareTemplateData() {
        const sortedBlocks = this.getSortedBlocks();
        
        return {
            title: this.templateTitle?.element?.textContent?.trim() || "",
            content: sortedBlocks.map(block => ({
                title: block.blockTitle?.element?.textContent || "",
                text: block.blockText?.element?.value || "",
            })),
            transcriptionId: this.transcription_id,
        };
    }

    async sendTemplateData(templateData) {
        const url = this.isEditMode ? this.edit_url : this.url;
        return await api.post(url, templateData);
    }

    handleSaveSuccess(data) {
        this.hide();
        this.resetForm();
        
        if (this.parentComponent?.handleTemplateSaved) {
            this.parentComponent.handleTemplateSaved(data);
        }
        
        if (this.parent?.box) {
            this.parent.box.show();
        }
        
        if (this.onSaveCallback) {
            this.onSaveCallback(data);
        }
    }

    handleSaveError(error) {
        if (error.response?.status) {
            console.error(`HTTP ошибка: ${error.response.status}`);
        } else {
            console.error(error);
        }
    }

    startLoading() {
        this.saveTemplateBtn?.addClass("loading");
        this.saveTemplateBtn.element.disabled = true;
    }

    stopLoading() {
        this.saveTemplateBtn?.removeClass("loading");
        this.saveTemplateBtn.element.disabled = false;
    }

    resetForm() {
        this.resetEditState();
        this.clearAllBlocks();
        this.createFirstBlock();
        this.clearTitle();
        this.updateMoveButtonsVisibility();
    }

    setParentCallback(parent) {
        this.parentComponent = parent;
    }

    onBack(callback) {
        this.btnBack?.on("click", () => {
            this.resetForm();
            callback?.();
        });
        
        this.cancelCreateBtn?.on("click", () => {
            this.resetForm();
            callback?.();
        });
    }

    onSave(callback) {
        this.onSaveCallback = callback;
    }

    createCard(element) {
        const tbx = this.tbx || window.Tbx;
        if (!tbx) return null;
        const component = tbx.createComponent(element);
        tbx.createComponents(null, element, component);
        return component;
    }
}